import React from "react";
import Autocomplete from "apollo-react/components/Autocomplete";
import Info from 'apollo-react-icons/Info';

const AutocompleteInput = ({
	field,
	meta,
	label,
	options,
	onChange,
	value,
	required,
	placeholder,
	disabled,
	multiple
}) => {
	return (
		<Autocomplete
			{...field}
			label={<span>{label} { <Info fontSize="extraSmall" style={{color:"#595959"}} />}</span>}
			placeholder={placeholder}
			helperText={
				meta?.touched && meta?.error ? meta.error : ""
			}
			source={options}
			fullWidth
			required={required}
			value={value}
			multiple={multiple}
			disabled={disabled}
			onChange={(event, newValue) => onChange(newValue)}
		/>
	);
};

export default AutocompleteInput;
